import { useEffect } from "react";
import { Form, Input, InputNumber, Select, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import "./service-excel.css";

const ServiceExcelProduct = ({ record, onSave, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
    }
  }, [record, form]);

  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedRecord = {
        ...record,
        ...values,
      };
      onSave(updatedRecord);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

  if (!record) return null;

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={(e) => e.target === e.currentTarget && onCancel()}
      >
        <div
          className="sport-modal-content service-excel-modal-content"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Редактирование продукта</span>
            <CloseCircleOutlined
              className="sport-section-title-close"
              onClick={onCancel}
            />
          </div>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Form.Item label="Внешний ID" name="externalId">
              <Input placeholder="Внешний ID" />
            </Form.Item>
            <Form.Item label="Наименование" name="name">
              <Input placeholder="Наименование" />
            </Form.Item>
            <Form.Item label="ед. изм." name="unit">
              <Input placeholder="ед. изм." />
            </Form.Item>
            <Form.Item label="Цена продажи" name="salePrice">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Цена продажи"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Вид" name="vid">
              <Select
                placeholder="Вид"
                options={[
                  { label: "Товар", value: 0 },
                  { label: "Услуга", value: 1 },
                  { label: "Абонемент", value: 2 },
                  { label: "Блок", value: 3 },
                ]}
              />
            </Form.Item>
            <Form.Item label="Зарплата исп. %" name="salaryExec">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Зарплата исп. %"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Зарплата прод. %" name="salarySale">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Зарплата прод. %"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Зарплата менеджеру %" name="salaryManager">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Зарплата менеджеру %"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Артикул" name="article">
              <Input placeholder="Артикул" />
            </Form.Item>
            <Form.Item label="Цена прихода" name="putPrice">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Цена прихода"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Длительность(мин.)" name="duration">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Длительность(мин.)"
              />
            </Form.Item>
            <Form.Item label="Срок" name="term">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Срок"
              />
            </Form.Item>
            <Form.Item label="Вид срока" name="termVid">
              <Select
                placeholder="Вид срока"
                options={[
                  { label: "<Нет>", value: 0 },
                  { label: "Дней", value: 1 },
                  { label: "Месяцев", value: 31 },
                  { label: "Лет", value: 365 },
                ]}
              />
            </Form.Item>
            <Form.Item label="Кол-во визитов" name="visitCount">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Кол-во визитов"
              />
            </Form.Item>
            <Form.Item label="Вид ограничения кол-ва визитов" name="visitLimitVid">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Вид ограничения кол-ва визитов"
              />
            </Form.Item>
            <Form.Item>
              <div className="service-excel-modal-actions">
                <Button onClick={onCancel}>Отмена</Button>
                <Button type="primary" onClick={handleSave}>
                  Сохранить
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

ServiceExcelProduct.displayName = "ServiceExcelProduct";

export default ServiceExcelProduct;

